const ANALYTICS_READY_TIMEOUT_MS = 5000;

let analyticsReady = false;
let resolveAnalyticsReady: (() => void) | null = null;

const analyticsReadyPromise = new Promise<void>((resolve) => {
  resolveAnalyticsReady = resolve;
});

export const markAnalyticsReady = (): void => {
  if (analyticsReady) {
    return;
  }

  analyticsReady = true;
  resolveAnalyticsReady?.();
  resolveAnalyticsReady = null;
};

export const waitForAnalyticsReady = async (): Promise<boolean> => {
  if (typeof window === "undefined") {
    return false;
  }

  if (analyticsReady) {
    return true;
  }

  return new Promise<boolean>((resolve) => {
    const timeoutId = window.setTimeout(() => resolve(false), ANALYTICS_READY_TIMEOUT_MS);

    void analyticsReadyPromise.then(() => {
      window.clearTimeout(timeoutId);
      resolve(true);
    });
  });
};
